import { pick } from "lodash";
import { BaseSearchParams } from "@radarly/models/search";

export const ERROR_CODE_TOO_FEW_POSTS = 78; // too few posts to process

export type PostlistSummaryError = {
  error: { code: typeof ERROR_CODE_TOO_FEW_POSTS; msg: string };
};

export const formatSummary = (summary: string) => {
  let res = summary.replace(/\\n-/g, "\n•"); // Replace list dashes with dots
  if (res.startsWith("\n")) res = res.slice(1); // Remove initial new line `\n` (considered as 1 char)

  return res;
};

export const getPostlistSummaryRequest = (request: BaseSearchParams) =>
  request && pick(request, ["query", "timezone"]);
